import rating from './rating'
import { ROLE_ADMIN, ROLE_USER } from '@/model/roles'

export default {
    rating,
    pageTitle: 'TREND RADAR - RATING - OVERVIEW',
    title: 'Welcome to the Trend Rating for Trend Radar',
    closed: 'The evaluation is closed.',
    progress: 'Evaluation progress',
    completed: {
        title: 'Trend evaluation completed',
        text: {
            [ROLE_USER]: 'Thanks for your evaluation.',
            [ROLE_ADMIN]: 'Thanks for your evaluation. You can view the status of this survey by clicking on the menu item Evaluation Management.'
        }
    }
}
